export default __webpack_public_path__ + "static/media/avatar_6.b5c1cb56.svg";